import { render, staticRenderFns } from "./FormChangePassword.vue?vue&type=template&id=01bbc4b9"
import script from "./FormChangePassword.vue?vue&type=script&lang=js"
export * from "./FormChangePassword.vue?vue&type=script&lang=js"
import style0 from "./FormChangePassword.vue?vue&type=style&index=0&id=01bbc4b9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports